import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').filter('activityState', statesFilter);

    /**
     * @returns {Function}
     * @author bjnowak.btc
     * @ngInject
     */
    function statesFilter(activitiesService) {
        return function (activities, state) {
            if (
                state === 'ALL' ||
                angular.isUndefined(state) ||
                angular.isUndefined(activities)
            ) {
                return activities;
            }

            var filtered = [];

            for (var i = 0; i < activities.length; i++) {
                var activity = activities[i];
                if (
                    activitiesService.FILTER[activity.category][state].indexOf(
                        activity.state
                    ) > -1
                ) {
                    filtered.push(activity);
                }
            }

            return filtered;
        };
    }
})();
